import {Injectable} from '@angular/core';
import {SnackBarService} from "./snack-bar.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {
    constructor(
        private snackBar: SnackBarService
    ) {}

    handleError(error): void {
        try {
            const message: any = error.message || 'Failed To Perform Action';
            this.snackBar.showNotification(message, 'error');
        } catch (e) {
            this.snackBar.showNotification('Failed To Perform Action', 'error');
        }
    }
}
